import clsx from 'clsx';
import React, { useMemo, useRef, useState } from 'react';
import { Button } from '../Button';
import Check from '@mollie/ui-assets/icons/utilitarian/Check';
import { Icon } from '../Icon';
import { ActionListDescendantsContext } from './ActionList';
import { useDescendant, useDescendantsContextSelector } from '../Descandants';
import { useComposedRefs, useDocumentListener } from '../../utils';
import { Box } from '../Box';
import Loader from '@mollie/ui-assets/icons/utilitarian/Loader';
export function ActionListItem(props) {
    const { children, description, prefix: userPrefix, postfix, className, selected, loading, disabled, index: indexProp, ...rest } = props;
    const [hasUsedKey, setHasUsedKey] = useState(false);
    const [element, setElement] = useState(null);
    const elementRef = useRef(null);
    const descendant = useMemo(() => ({ element }), [element]);
    const activeIndex = useDescendantsContextSelector(ActionListDescendantsContext, ({ activeIndex }) => activeIndex);
    const setActiveIndex = useDescendantsContextSelector(ActionListDescendantsContext, ({ setActiveIndex }) => setActiveIndex);
    const index = useDescendant(descendant, ActionListDescendantsContext, indexProp);
    useDocumentListener('keyup', () => {
        var _a;
        if ((_a = elementRef.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement)) {
            setHasUsedKey(true);
        }
        else {
            setHasUsedKey(false);
        }
    });
    useDocumentListener('mouseup', () => {
        setHasUsedKey(false);
    });
    const composedElementRef = useComposedRefs(setElement, elementRef);
    const prefix = loading ? React.createElement(Icon, { src: Loader, spinning: true }) : userPrefix;
    return (React.createElement("li", { role: "presentation" },
        React.createElement(Button, { ...rest, unstyled: true, role: "menuitem", ref: composedElementRef, onFocus: () => {
                setActiveIndex(index);
            }, "aria-current": selected ? 'true' : undefined, disabled: loading || disabled, className: clsx('mollie-ui-action-list-item', {
                'mollie-ui-action-list-item--active': activeIndex === index && hasUsedKey,
                'mollie-ui-action-list-item--loading': !!loading,
            }, className), onMouseMove: () => {
                setActiveIndex(index);
                setHasUsedKey(false);
            }, UNSAFE_contentClassName: "mollie-ui-action-list-item-content-wrapper" },
            prefix && (React.createElement(Box, { className: "mollie-ui-action-list-secondary" }, prefix)),
            React.createElement("div", { className: "mollie-ui-action-list-item-content" },
                children && (React.createElement("span", { className: "mollie-ui-action-list-label" }, children)),
                description && (React.createElement("span", { className: "mollie-ui-action-list-secondary" }, description))),
            selected && (React.createElement(Icon, { className: "mollie-ui-action-list-selected", src: Check })),
            postfix && (React.createElement(Box, { className: "mollie-ui-action-list-secondary", marginInlineStart: "auto" }, postfix)))));
}
ActionListItem.displayName = 'ActionList.Item';
//# sourceMappingURL=ActionListItem.js.map